export default {
  label: '产品总监',
  id: '0',
  children: [
    {
      label: '定义',
      id: '0-1',
      children: [
        {
          label: '多条产品线的战略决策者。',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '职责',
      id: '0-2',
      children: [
        {
          label: '负责市场分析和产品规划，制定产品战略，推动产品落地。',
          id: '0-2-1',
        },
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '具备全面的市场和产品管理能力，能够制定长期产品规划。',
          id: '0-3-1',
        },
      ],
    },
    {
      label: '职业发展',
      id: '0-4',
      children: [
        {
          label: '通常在10年以上经验后成为公司高层领导，晋升CPO（首席产品官）或转向综合管理。',
          id: '0-4-1',
        },
      ],
    },
    {
      label: '薪资水平',
      id: '0-5',
      children: [
        {
          label: '月薪25,000-50,000元之间，年薪可达50-100万元。',
          id: '0-5-1',
        },
      ],
    },
  ],
};